<template>
    <v-tooltip bottom>
        <template #activator="{ on, attrs }">
            <app-icon-button
                v-bind="attrs"
                :icon="icon"
                :color="active ? 'primary' : 'grey'"
                :disabled="disabled"
                small
                v-on="on"
                @click="$emit('click')" />
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
import AppIconButton from '@/components/AppIconButton.vue'

export default {
    name: 'RichTextAreaToolbarButton',
    components: { AppIconButton },
    props: {
        icon: { type: String, required: true },
        tooltip: { type: String, required: true },
        active: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false }
    }
}
</script>



